import React from "react";

const error = () => {
  return <div>error page</div>;
};

export default error;
